import { localStorage } from '@muse-web/storages'

import { STORAGE_KEYS } from './storageKeys'

export const readVisitsCounter = (): number => {
    if (typeof window === 'undefined') {
        return 0
    }

    const parsed = Number(localStorage.get(STORAGE_KEYS.visitsCounter))

    return Number.isFinite(parsed) ? parsed : 0
}

export const writeVisitsCounter = (next: number): void => {
    if (typeof window === 'undefined') {
        return
    }

    localStorage.set(STORAGE_KEYS.visitsCounter, String(next))
}
